import React from "react";
import { usePermissionTabs } from "../../hooks/usePermissionTabs";
import { PermissionTabManager } from "../../components/PermissionTabManager";
import InventoryTabMain from "./inventory-tab";
import InverntoryProduct from "./inverntory-product";
import ShelveManagement from "./inventory-shelve"; 

const tabs = [
  {
    key: "Product",
    label: "Product",
    component: <InverntoryProduct />,
    modules: ["product_inventory", "products"],
    operation: "read",
  },
  {
    key: "Shelve",
    label: "Shelve",
    component: <ShelveManagement />,
    modules: ["shelves"],
    operation: "read",
  },
  // {
  //   key: "Inventory",
  //   label: "Inventory",
  //   component: <InventoryTabMain />,
  //   modules: ["shipment_inventory", "product_inventory"],
  //   operation: "read",
  // },
];

const InventoryMangement: React.FC = () => {
  const result = usePermissionTabs({ tabs, param: "tab" });

  return (
    <PermissionTabManager
      // title="Inventory Management"
      visibleTabs={result.visibleTabs}
      activeLabel={result.activeLabel}
      content={result.content}
      isLoading={result.isLoading}
      error={result.error}
      handleChange={result.handleChange}
      tabPosition={result.activeKey === "Product" ? "right" : "left"}
      subClassName="space-y-0"
    />
  );
};

export default InventoryMangement;
